export default __webpack_public_path__ + "static/media/dog2.8adb46cc.jpg";